
export default {
    props: {
        drug: {
            type: Object,
            default: null
        }
    },
}
